<template>
  <el-dialog
    destroy-on-close
    :visible.sync="localVisible"
    :title="type === 'add' ? '创建任务' : '任务详情'"
    width="800px"
    @close="handleClose"
  >
    <el-form
      :rules="rules"
      :model="form"
      ref="ruleForm"
      label-width="100px"
      class="task-form"
    >
      <el-form-item label="任务名称" prop="name">
        <el-input
          :disabled="canEdit ? false : isView"
          v-model="form.name"
          maxlength="64"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="目标完成时间" prop="targetCompletionTime">
            <el-date-picker
              :disabled="canEdit ? false : isView"
              style="width: 100%"
              v-model="form.targetCompletionTime"
              type="date"
              placeholder="选择日期"
              format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="优先级" prop="priority">
            <el-select
              :disabled="canEdit ? false : isView"
              v-model="form.priority"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="level in priorityLevels"
                :key="level.value"
                :label="level.label"
                :value="level.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="任务内容" prop="content">
        <el-input
          :disabled="canEdit ? false : isView"
          maxlength="2000"
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 5 }"
          v-model="form.content"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="相关附件" prop="relAttachmentsList">
        <file-upload
          v-if="type === 'add' || canEdit"
          class="upload-demo"
          ref="fileUpload"
          drag
          :action="'/file/upload'"
          :show-file-list="true"
          :my-file-list.sync="form.relAttachmentsList"
        >
        </file-upload>
        <div v-else>
          <div class="image-item">
            <el-image
              style="width: 100px; height: 100px; margin-right: 5px"
              fit="contain"
              v-for="image in imageList"
              :preview-src-list="imageList.map((item) => item.originUrl)"
              :src="image.thumbUrl || image.originUrl"
              :key="image.fileKey"
              :alt="image.fileKey"
            />
          </div>
          <div
            class="file-item"
            v-for="file in fileList"
            :key="file.fileKey"
            @click="handleOpenFile(file)"
          >
            {{ file.fileKey }}
          </div>
        </div>
      </el-form-item>
      <el-form-item label="指派给" prop="userIdList">
        <el-select
          :disabled="canEdit ? false : isView"
          v-model="form.userIdList"
          multiple
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option
            v-for="item in people"
            :key="item.id"
            :label="item.nickName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="任务状态" v-if="type === 'edit'" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio
            v-for="item in taskStatus"
            :key="item.value"
            :label="item.value"
            >{{ item.label }}</el-radio
          >
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleConfirm" v-loading="submitLoading"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { priorityLevels } from "@/api/enums";
import FileUpload from "@/components/common/FileUploadForTask.vue";
import fileImg from "@/assets/image/fileImg.png";
import UserApi from "@/api/user";
import { addTask, editTaskStatus } from "../../api/task";
import { formatDateTime } from "../../api/date";
import bus from "./bus";
import { taskStatus } from "../../api/enums";
const UAPI = new UserApi();
export default {
  components: {
    FileUpload,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    type: {
      type: String,
      default: "add",
    },
    record: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    mine() {
      return this.$store.state.userStore.userInfo;
    },
    isView() {
      return this.type === "edit";
    },
    canEdit() {
      return (
        this.isView &&
        this.record.status === 1 &&
        this.record.userId === this.mine.id
      );
    },
  },
  data() {
    return {
      bus,
      localVisible: this.visible,
      priorityLevels,
      rules: {
        name: [{ required: true, message: "请输入任务名称", trigger: "blur" }],
        userIdList: [
          { required: true, message: "请选择指派人", trigger: "blur" },
        ],
      },
      form: {
        name: "",
        targetCompletionTime: "",
        priority: "medium",
        content: "",
        userIdList: [],
        relAttachmentsList: [],
      },
      imageList: [],
      fileList: [],
      people: [],
      taskStatus,
      submitLoading: false,
    };
  },
  mounted() {
    console.log("canEdit", this.canEdit);
  },
  watch: {
    visible(val) {
      this.localVisible = val;
      if (this.type === "edit") {
        this.form = {
          ...this.record,
          userIdList: (this.record.userList || []).map((item) => item.id),
        };
        this.convertFiles(this.record.relAttachmentsList || []);
      }
      if (val) {
        this.getUserList();
      }
    },
    localVisible(val) {
      this.$emit("update:visible", val);
    },
  },
  methods: {
    handleOpenFile(file) {
      window.open(file.originUrl);
    },
    convertFiles(arr) {
      const isImage = [".png", ".jpg", "jpeg", ".gif"];
      this.form.relAttachmentsList = arr.map((item) => {
        return {
          ...item,
          url: isImage.some((type) =>
            item.fileKey.toLocaleLowerCase().includes(type)
          )
            ? item.thumbUrl || item.originUrl
            : fileImg,
          name: item.fileKey,
          response: {
            ...item,
          },
          isSuccess: true,
        };
      });
      this.imageList = arr.filter((item) =>
        isImage.some((type) => item.fileKey.toLocaleLowerCase().includes(type))
      );
      this.fileList = arr.filter(
        (item) =>
          !isImage.some((type) =>
            item.fileKey.toLocaleLowerCase().includes(type)
          )
      );
    },
    handleClose() {
      this.$refs["ruleForm"].resetFields();
      this.localVisible = false;
    },
    handleConfirm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (!valid) return;
        if (this.submitLoading) return;
        this.submitLoading = true;
        const params =
          this.canEdit || this.type === "add"
            ? {
                ...this.form,
                relAttachmentsList: this.form.relAttachmentsList
                  .filter((item) => item.response)
                  .map((item) => item.response),
                targetCompletionTime: formatDateTime(
                  this.form.targetCompletionTime,
                  "-"
                ),
              }
            : {
                id: this.form.id,
                status: this.form.status,
              };
        debugger;
        const api =
          this.canEdit || this.type === "add" ? addTask : editTaskStatus;
        api(params)
          .then((res) => {
            this.$message.success("操作成功");
            this.bus.$emit("Refresh");
            debugger;
            this.localVisible = false;
            this.$emit("confirm");
          })
          .finally(() => {
            this.submitLoading = false;
          });
      });
    },
    getUserList() {
      UAPI.getAllUser().then((res) => {
        console.log(res);
        this.people = res.data;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.dialog-footer {
  text-align: right;
}

.task-form {
  width: 100%;
  margin: 0 auto;

  .upload-demo {
    width: 100%;
    min-height: 164px;
    // border: 1px dashed #d9d9d9;
    border-radius: 4px;
    // background-color: #fafafa;
    text-align: center;
    cursor: pointer;

    &:hover {
      border-color: #409eff;
    }
    :deep(.el-upload) {
      width: 100%;
      height: 164px;
      .el-upload-dragger {
        width: 100%;
        height: 100%;
      }
    }
    :deep(.el-upload-list__item-name) {
      text-align: left;
    }
  }

  .file-list {
    list-style: none;
    padding: 0;
    margin: 0;

    .file-item {
      display: flex;
      justify-content: space-between;
      padding: 5px 0;
      border-bottom: 1px solid #eaeaea;
    }
  }

  .assignees {
    display: flex;
    flex-wrap: wrap;

    .assignee {
      background-color: #f0f0f0;
      border-radius: 50%;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 5px;
      font-size: 14px;
    }

    .add-assignee {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #d9d9d9;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      margin: 5px;
    }
  }

  :deep(.el-input.is-disabled .el-input__inner) {
    // background: #fff;
    // cursor: initial;
  }

  .image-item {
    img {
      width: 80px;
      height: 80px;
      object-fit: contain;
    }
  }
  .file-item {
    cursor: pointer;
    font-size: 18px;
    font-weight: bold;
  }
}
</style>
